<template>
  <div class="overlay" v-if="IsSuccessful">
    <div class="dealer-submit-box">
    <h3>{{ SubmitTerritoryName }} has been {{ IsMode }} successfully!</h3>
    <button class="dealer-submit-confirm-btn" @click="handleConfirm">OK</button>
  </div>
  </div>
  <div class="territory-comp-cont">
    <h1 class="territory-comp-header">Territory Editor</h1>
    <div class="territory-table-page">
      <TerritoryTable style="width: 100%;" />
      <div class="territory-comp-form-headers">
        <div class="territory-comp-form-head" v-if="Mode === 'edit'">Edit Territory</div>
        <div class="territory-comp-form-head" v-else>Add Terrritory</div>
        <TerritoryForm :dataInputs="TerritoryInputs" />
      </div>
    </div>
  </div>
</template>

<script>
import { useTerritoryStore } from '@/store/TerritoryStore';
import TerritoryForm from './TerritoryForm.vue';
import TerritoryTable from './TerritoryTable.vue';

export default {
  components: {
    TerritoryForm,
    TerritoryTable
  },
  computed: {
    IsSuccessful () {
      return useTerritoryStore().isSuccessful;
    },
    SubmitTerritoryName () {
      return useTerritoryStore().submitTerritoryName;
    },
    Mode () {
      return useTerritoryStore().Mode;
    },
    TerritoryInputs () {
      const territoryStore = useTerritoryStore();
      if (this.Mode === 'edit') {
        return territoryStore.EditTerritoryInputs;
      } else {
        return territoryStore.CreateTerritoryInputs;
      }
    },
        IsMode () {
      return useTerritoryStore().isMode;
    }
  },
  methods: {
    handleConfirm () {
      useTerritoryStore().isMode = 'default';
      useTerritoryStore().isSuccessful = false;
    }
  }
};
</script>

<style scoped>
.territory-comp-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.territory-table-add-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100px;
  cursor: pointer;
}
.territory-table-add-btn-icon {
  width: 20px;
}
td {
  text-align: center;
}
.territory-table-page {
  display: flex;
  flex-wrap: row;
  justify-content: center;
  gap: 10px;
  width: 100%;
}
.territory-comp-form-headers {
  width: 40%;
  max-height: 90vh;
  overflow-y: auto;
}
.territory-comp-form-head {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}
.territory-comp-header {
  padding-bottom: 20px;
}
.overlay {
          position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex; /* Flexbox for centering */
        justify-content: center;
        align-items: flex-start;
        padding-top: 20px;
        backdrop-filter: #7f7f7f; /* Blur everything behind */
        background-color: rgba(0, 0, 0, 0.3); /* Optional dark tint */
        z-index: 99999999; /* Ensure it’s on top */
}
.dealer-submit-box {
         background: white;
        padding: 20px 40px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        text-align: center;
        max-width: 400px
}
.dealer-submit-confirm-btn {
  cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    color: #FFFFFF;
    padding: 5px;
    width: 70px;
    text-align: center;
    margin-top: 10px;
    background-color: var(--nelson-green);
}
</style>